import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type CardType = 'learn' | 'challenge';
export type CardStatus = 'pending' | 'completed' | 'skipped';

export interface Card {
    id: string;
    type: CardType;
    wordId: number;
    status: CardStatus;
    order: number;
}

interface LearnState {
    cards: Card[];
    currentCardIndex: number;
}

const initialState: LearnState = {
    cards: [],
    currentCardIndex: 0,
};

const learnSlice = createSlice({
    name: 'learn',
    initialState,
    reducers: {
        setCards: (state, action: PayloadAction<Card[]>) => {
            state.cards = action.payload;
        },
        setCurrentCardIndex: (state, action: PayloadAction<number>) => {
            state.currentCardIndex = action.payload;
        },
        updateCardStatus: (state, action: PayloadAction<{ index: number; status: CardStatus }>) => {
            const { index, status } = action.payload;
            if (index >= 0 && index < state.cards.length) {
                state.cards[index].status = status;
            }
        },
    },
});

export const learnActions = learnSlice.actions;
export default learnSlice.reducer; 